import { indexItems } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">主题索引</h2>
          <p className="mt-2 text-sm text-foreground-600">按分类快速浏览黑料网站大全资源合集</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item) => (
            <div
              key={item.id}
              className="group flex gap-4 p-5 bg-background-50 rounded-lg border border-background-200 hover:border-primary-200 transition-all cursor-pointer"
            >
              <span className="flex-shrink-0 w-10 h-10 flex items-center justify-center text-lg font-heading font-bold text-primary-500 bg-primary-100 rounded-lg">
                {item.letter}
              </span>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between">
                  <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                    {item.title}
                  </h3>
                  <span className="text-[11px] text-foreground-500 whitespace-nowrap">{item.count}</span>
                </div>
                <p className="mt-1 text-xs text-foreground-600 leading-relaxed">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}